<template>
  <pt-third-vendors class="pt-third-vendors__page"></pt-third-vendors>
</template>

<script>
import PtThirdVendors from 'cps/mall-manage/pt-third-vendors/withData'
export default {
  name: 'pt-third-vendors__view',
  components: {
    'pt-third-vendors': PtThirdVendors
  }
}
</script>
